import LoyaltyCardSFC from "./LoyaltyCard.vue";
export const LoyaltyCard = LoyaltyCardSFC;
